export default __webpack_public_path__ + "open-watchlist-ed544505c8cfd279137d6f6afa9ec742.svg";